import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ExamDefinitionCreate } from "@/features/catalog";
import { examDefinitionRouteId } from "@/features/catalog/lib/exam-definition-route";
import { canWriteExamDefinitions } from "@/features/catalog/lib/exam-permissions";

export const Route = createFileRoute("/catalog/exams/new")({
  beforeLoad: ({ context }) => {
    if (!canWriteExamDefinitions(context.permissions)) throw redirect({ to: "/catalog/exams" });
  },
  component: NewExamDefinition,
});

function NewExamDefinition() {
  const navigate = useNavigate();
  return (
    <ExamDefinitionCreate
      onDone={(url) => navigate({ to: "/catalog/exams/$examId", params: { examId: examDefinitionRouteId(url) } })}
      onCancel={() => navigate({ to: "/catalog/exams" })}
    />
  );
}
